import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { message } from "antd";

const SelectPartner = ({
  onSelectPartner,
  selectedValue,
  isDisabled = false,
}) => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  // Define static options
  const staticOptions = [
    { value: "0", label: "Walk-In" },
    { value: "1", label: "Corporate" },
  ];

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${apiUrl}/hms-partners/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success && Array.isArray(response.data.partners)) {
        // Filter for active partners only
        const activePartners = response.data.partners
          .filter((partner) => partner.status === "active")
          .map((partner) => ({
            value: partner.id.toString(),
            label: partner.name,
            partnerDetails: partner,
          }));

        // Combine static options with fetched active partners
        const formattedOptions = [...staticOptions, ...activePartners];

        setPartners(formattedOptions);
      } else {
        throw new Error("Invalid response format: 'partners' array not found");
      }
    } catch (error) {
      console.error("Error fetching partners:", error);
      setError("Failed to load partners. Please try again.");
      setPartners([...staticOptions]); // Fallback to static options
      message.error("Error fetching partners.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Select
      options={partners}
      onChange={(selectedOption) => {
        // Pass both value and label as an object
        onSelectPartner({
          value: selectedOption ? selectedOption.value : null,
          name: selectedOption ? selectedOption.label : null,
        });
      }}
      value={partners.find((option) => option.value === selectedValue?.value) || partners[0] || null}
      placeholder="Select Partner"
      isLoading={loading}
      isDisabled={isDisabled || loading || !!error}
      noOptionsMessage={() =>
        error ? error : loading ? "Loading..." : "No partners available"
      }
      isClearable
    />
  );
};

export default SelectPartner;